<div [ngClass]="{'filters-opened': showMobileFilters}">
  <form cdkScrollable #searchForm [style]="fixedSnackHeight" class="no-print" (ngSubmit)="applySearch()">
    <div class="flex space-between" *ngIf="showMobileFilters && utilService.isMobile">
      <span class="heading-2 break-word">{{ 'general.api_payment_reversal_search_filters' | translate }}</span>
      <div class="align-right">
        <button mat-button class="icon-button" (click)="toggleFilters()">
          <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
        </button>
      </div>
    </div>
    <div class="heading-1 hidden-on-scroll" *ngIf="!showMobileFilters || !utilService.isMobile">
      {{'general.api_menu_payment_reversal' | translate}}
      <div class="pull-right flex" *ngIf="!utilService.isMobile">
        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
      </div>
    </div>
    <app-loader [loading]="updatingData || isLoading" [filterOverlay]="true" [size]="64"></app-loader>
    <div class="mobile-search mobile flex flex-grow flex-filters">
      <!-- MOBILE DATE RANGE -->
      <app-datepicker [(dateStart)]="filters.reversalStartDate" [(dateEnd)]="filters.reversalEndDate"
                      [datePickerConfig]="dateRangeConfig" (dateChanged)="!showMobileFilters && applyMobileDateChange()"
                      [ngClass]="{'bottom-spacer': showMobileFilters && utilService.isMobile}"></app-datepicker>
      <button type="button" *ngIf="!showMobileFilters" mat-button class="icon-button input-button mobile" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'filters'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-wrap flex-filters" [ngClass]="{'desktop' : !showMobileFilters || !utilService.isMobile, 'flex-column-mobile with-footer' : utilService.isMobile && showMobileFilters}">
      <!-- DATE RANGE -->
      <app-datepicker [(dateStart)]="filters.reversalStartDate" [(dateEnd)]="filters.reversalEndDate"
                      [datePickerConfig]="dateRangeConfig" class="desktop"></app-datepicker>
      <!-- ORDER CONFIRMATION -->
      <app-numeric-input [label]="'general.api_payment_reversal_order_confirmation'" [(value)]="filters.orderConfirmation" [ignoreMax32]="true"></app-numeric-input>
      <div class="flex flex-flat">
        <!-- EVENT STATUS -->
        <mat-form-field appearance="outline" class="no-hint prefix-field condensed">
          <mat-label>{{'general.api_reports_event_status' | translate}}</mat-label>
          <mat-select [(ngModel)]="eventStatusId" [ngModelOptions]="{standalone: true}">
            <mat-select-trigger>{{displayFilterSelectedOption(eventStatusId, eventStatuses) | translate}}</mat-select-trigger>
            <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
            <mat-option *ngFor="let status of eventStatuses" [value]="status.id">
              {{status.name | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- EVENT NAME -->
        <app-scroll-load [label]="'general.api_reports_event_name'" [minInput]="3" [withPrefix]="true"
                         [customFilters]="{statusIds: [eventStatusId]}" [clearOnBlur]="true"
                         [searchService]="eventService" [scrollLoad]="eventScrollLoad"
                         [(selectedObjectId)]="filters.eventId"></app-scroll-load>
      </div>
      <div class="flex flex-end desktop">
        <ng-container *ngTemplateOutlet="formButtons"></ng-container>
      </div>
    </div>
    <footer class="mobile">
      <mat-dialog-actions>
        <ng-container *ngIf="showMobileFilters">
          <ng-container *ngTemplateOutlet="formButtons"></ng-container>
        </ng-container>
        <ng-container *ngIf="!showMobileFilters">
          <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        </ng-container>
      </mat-dialog-actions>
    </footer>

    <ng-container *ngIf="!showMobileFilters || !utilService.isMobile">
      <mat-tab-group mat-align-tabs="left" class="tabs no-body max-width top-spacer"
                     [(selectedIndex)]="activeStatusTab" (selectedIndexChange)="changeTab()">
        <mat-tab [label]="'general.api_payment_reversal_status_' + tab.toLowerCase() | translate" *ngFor="let tab of statusTabs"></mat-tab>
      </mat-tab-group>
      <div class="body-2 text-muted top-spacer" *ngIf="!isLoading && !hasResults && !noSearches">
        <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
        {{ 'general.api_payment_reversal_empty' | translate }}
      </div>
      <div class="body-2 text-muted top-spacer" *ngIf="!isLoading && !hasResults && noSearches">
        <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
        {{ 'general.api_payment_reversal_choose_filter' | translate }}
      </div>
    </ng-container>
  </form>
</div>

<ng-template #formButtons>
  <button mat-button type="button" (click)="clearFilters()">
    {{ 'general.api_general_clear' | translate }}
  </button>
  <button type="submit" mat-flat-button color="primary" [disabled]="!validationService.emptyOrNumeric(filters.orderConfirmation, true)">
    {{ 'general.api_payment_reversal_search' | translate }}
  </button>
</ng-template>

<ng-template #actionButtons>
  <button type="button" mat-stroked-button color="primary" [disabled]="!buttonsEnabled || !selectedIds?.length" (click)="refundClicked.emit()">
    {{ 'general.api_payment_reversal_send_to_refund' | translate }}
  </button>
  <button type="button" mat-stroked-button color="primary" [disabled]="isLoading || !filters.eventId || eventId !== filters.eventId" (click)="refundAllClicked.emit()">
    {{ 'general.api_payment_reversal_refund_all' | translate }}
  </button>
</ng-template>
